import { render, staticRenderFns } from "./NuovoPreventivo.vue?vue&type=template&id=1aad9411&"
import script from "./NuovoPreventivo.ts?vue&type=script&lang=ts&"
export * from "./NuovoPreventivo.ts?vue&type=script&lang=ts&"
import style0 from "./NuovoPreventivo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports